export default __webpack_public_path__ + "static/flag-es-3f0cee3ad34d3415a898b3c69ef3a53a.svg";